<template>
  <el-dialog :visible.sync="showDialog"  :close-on-click-modal="false" @close="handleResetOrClose">
    <template #title>
      <h4>{{ $t('lang.导出食谱') }}</h4>
    </template>
    <el-form label-width="auto" ref="form" :model="formData">
      <el-form-item :label="$t('lang.文件名')" prop="fileName" :rules="{ required: true, message: $t('lang.文件名不能为空'), trigger: 'blur' }">
        <el-input :placeholder="$t('lang.文件名')" v-model="formData.fileName" />
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.语言分类')" prop="lang" :rules="{ required: true, message: this.$t('lang.请选择语言'), trigger: 'change' }">
        <el-select clearable v-model="formData.lang">
          <el-option v-for="item in supportLangList" :key="item.value" :value="item.value"
                     :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleExport">{{$t('lang.导出')}}</el-button>
        <el-button @click="handleResetOrClose">{{$t('lang.重置')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "RecipeExport",
  data() {
    return {
      showDialog: false,
      formData: {
        fileName: '',
        lang: "",
      },
      params: null,
      timer: null,
      rules: {
        fileName: [{ required: true, message: this.$t('lang.文件名不能为空'), trigger: 'blur' }],
        lang: [{ required: true, message: this.$t('lang.请选择语言'), trigger: 'change' }],
      }
    }
  },
  methods: {
    handleExport() {
      this.$refs.form.validate((valid) => {
        if(!valid) return;
        this.$customLoading.showLoading(this, "导出中");
        let params = Object.assign({}, this.params, this.formData)
        this.$http.post(this.$api.recipe.export, this.$qs.stringify(params)).then(res => {
          if(res.data.status != 200) {
            this.$message.error(res.data.desc);
            this.$customLoading.hideLoading();
            return;
          }
          console.log("res", res);
          this.handleCheckState(res);
        }).catch(err => {
          this.$customLoading.hideLoading();
          console.log('err', err);
        })
        this.showDialog = false
      })
    },

    // 判断状态
    handleCheckState(res) {
      let asyncTask = res.data.data.asyncTask;
      let result = null;
      switch (asyncTask.status) {
        case  "RUNNING":
          this.handleCheckDownloadState(asyncTask.code)
          break;
        case  "FINISH":
          result = JSON.parse(asyncTask.result);
          this.handleDownloadFile(this.$api.file.download+'?fileCode='+result.fileCode);
          this.$customLoading.hideLoading();
          break;
        case  "ERROR":
          this.$message.error(this.$t('lang.导出失败'));
          this.$customLoading.hideLoading();
          break;
      }
    },

    // 轮询检测导出状态
    handleCheckDownloadState(code) {
      this.timer = setTimeout(() => {
        this.$http.post(this.$api.recipe.asyncTaskDetail, this.$qs.stringify({code})).then(res => {
          this.handleCheckState(res);
        }).catch(err => {
          console.log('err', err);
        })
      }, 2000)
    },

    // 创建a标签下载
    handleDownloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.click();
      a.remove();
    },

    handleResetOrClose() {
      this.formData = {
        fileName: '',
        lang: "",
      }
      this.$refs.form.resetFields();
    },

    handleShowExportDialog(params) {
      this.params = params;
      this.showDialog = true
    }
  },
  computed: {
    supportLangList() {
      return this.$store.state.supportLangList;
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  }
}
</script>

<style scoped>

h4 {
  padding: 0;
  margin: 0;
}

/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}

.el-select {
  width: 100%;
}


</style>
